export class ImagicaFeature {
    constructor() {
        this.name = "";
        this.value = "";
        this.description = "";
        this.short_description = "";
        this.plans = [];
        this.minimum_plan = "";
    }
}
